import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center sm:items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_3 = { class: "w-full sm:my-8 sm:align-middle sm:max-w-screen-sm sm:w-auto sm:p-6 md:max-w-screen-md lg:max-w-screen-lg inline-block align-bottom bg-white text-black rounded-lg px-4 pt-5 pb-4 text-left overflow-auto shadow-xl transform transition-all" }
const _hoisted_4 = { class: "hidden sm:block absolute top-0 right-0 pt-4 pr-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close", -1)
const _hoisted_6 = { class: "sm:flex sm:flex-col sm:items-start" }
const _hoisted_7 = { class: "mt-5 sm:mt-4 sm:flex sm:flex-row-reverse" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogOverlay = _resolveComponent("DialogOverlay")!
  const _component_TransitionChild = _resolveComponent("TransitionChild")!
  const _component_XIcon = _resolveComponent("XIcon")!
  const _component_DialogTitle = _resolveComponent("DialogTitle")!
  const _component_AutoTeleportRoot = _resolveComponent("AutoTeleportRoot")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_TransitionRoot = _resolveComponent("TransitionRoot")!

  return (_openBlock(), _createBlock(_component_TransitionRoot, {
    as: "template",
    show: _ctx.open
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Dialog, {
        as: "div",
        "auto-reopen": "true",
        class: "fixed z-40 inset-0 overflow-y-auto",
        onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_AutoTeleportRoot, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_TransitionChild, {
                  as: "template",
                  enter: "ease-out duration-300",
                  "enter-from": "opacity-0",
                  "enter-to": "opacity-100",
                  leave: "ease-in duration-200",
                  "leave-from": "opacity-100",
                  "leave-to": "opacity-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DialogOverlay, { class: "fixed inset-0 bg-gray-700 bg-opacity-80 transition-opacity backdrop-filter backdrop-blur-sm" })
                  ]),
                  _: 1
                }),
                _hoisted_2,
                _createVNode(_component_TransitionChild, {
                  as: "template",
                  enter: "ease-out duration-300",
                  "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                  "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                  leave: "ease-in duration-200",
                  "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                  "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "rounded-sm text-gray-400 hover:text-gray-500",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                        }, [
                          _hoisted_5,
                          _createVNode(_component_XIcon, {
                            class: "h-6 w-6",
                            "aria-hidden": "true"
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_DialogTitle, { class: "sm:pr-8 font-bold text-xl" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.title), 1)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", {
                          class: _normalizeClass({ 'mt-2': true, prose: _ctx.prose })
                        }, [
                          _renderSlot(_ctx.$slots, "default")
                        ], 2)
                      ]),
                      _createElementVNode("div", _hoisted_7, [
                        _renderSlot(_ctx.$slots, "footer")
                      ])
                    ])
                  ]),
                  _: 3
                })
              ])
            ]),
            _: 3
          })
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["show"]))
}